export default __webpack_public_path__ + "static/media/arrowUp.0d779040.svg";